module.exports = __webpack_public_path__ + "static/media/yellow_nebula_BK.bf6975e3.png";